import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import EmployeeListRequest from "../request/EmployeeListRequest";
import { EmployeeListApiResponse } from "../model/Employee";

export const EmployeeListSearchApiService = async (
  request: EmployeeListRequest
): Promise<EmployeeListApiResponse> => {
  const url = "/employees/";

  if (!request.search || request.search.length < 1) {
    return { count: 0, pages: 0, results: [] };
  }
  const { data } = await axios.get(url, {
    params: request,
  });
  if (data?.results) {
    return data;
  }
  // Paginated & non paginated results have different return types
  return { results: data, count: data.length, pages: 0 };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeListSearchApiService = (request: EmployeeListRequest) =>
  useQuery<
    Promise<EmployeeListApiResponse>,
    AxiosError,
    EmployeeListApiResponse
  >(
    ["EmployeeListSearchApiService", ...Object.values(request)],
    () => EmployeeListSearchApiService(request),
    { keepPreviousData: true }
  );

export default useEmployeeListSearchApiService;
